<template>
       <div class="container">
                <div class="page-header">
                    <div class="page-title">
                     
                        <div class="crumbs">
                            <ul id="breadcrumbs" class="breadcrumb">
                                 <li>
                                  <router-link :title="'الرئيسيه'" :to="{name: 'dashboard'}"> <i class="flaticon-home-fill"></i> الرئيسيه</router-link>
                                </li>
                                <li>
                                  <router-link :title="'المقابلات'" :to="{name: 'interviews'}">المقابلات</router-link>
                                </li>
                                 <li class="active">
                                  <router-link :title="'إضافة جديد'" :to="{name: 'interviews.create'}">إضافة جديد</router-link>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
                

                <div class="row">

                    <div class="col-lg-12 col-lg-12 col-md-12 col-sm-12 col-12  layout-spacing">
                        <div class="statbox widget box box-shadow">
                            <div class="widget-header">                                
                                <div class="row">
                                    <div class="col-xl-12 col-md-12 col-sm-12 col-12">
                                        <h4>
                                          <i class="flaticon-computer-4"></i> 
                                          بيانات المقابلة</h4>
                                    </div>
                                </div>
                            </div>
                            <div class="widget-content widget-content-area">
                              <ul class="nav nav-tabs" id="myTab" role="tablist">
                                <li class="nav-item">
                                  <a class="nav-link active" id="personal-tab" data-toggle="tab" href="#personal" role="tab" aria-controls="personal" aria-selected="true"><i class="fa-regular fa-user text-primary"></i> بيانات الطالب</a>
                                </li>
                                <li class="nav-item">
                                  <a class="nav-link" id="contact-tab" data-toggle="tab" href="#contact" role="tab" aria-controls="contact" aria-selected="false"><i class="fa-regular fa-user-circle text-primary"></i> خاص بإدارة الحلقات</a>
                                </li>
                                <li class="nav-item">
                                  <a class="nav-link" id="ident-tab" data-toggle="tab" href="#ident" role="tab" aria-controls="ident" aria-selected="false"><i class="fa-regular fa-file text-primary"></i> معلومات قبول الطالب</a>
                                </li>
                              </ul>
                              <form @submit.prevent="store()">
                                <div class="tab-content" id="myTabContent">
                                  <div class="tab-pane fade show active" id="personal" role="tabpanel" aria-labelledby="personal-tab">
                                    <div class="row mt-4">
  <div class="col-md-4">
                                              <label for="exampleFormControlInput12">الاسم <span class="text-danger">*</span></label>
                                  <div class="input-group mb-4">
                                      
                                      <div class="input-group-prepend">
                                        <span class="input-group-text" id="basic-addon1"><i class="flaticon-file"></i></span>
                                      </div>
                                            <input type="text" class="form-control" id="exampleFormControlInput12" v-model="data.form.name" placeholder="الاسم كامل">
                                            <div class="invalid-feedback" :style="getErrors['name'] ? 'display: block' : 'display: none;'"  v-if="getErrors['name']">
                                                  {{ getErrors['name'][0] }}
                                            </div>
                                        </div>
                                      </div>
                                      
                                       <div class="col-md-4">
                                        <div class="form-group mb-4">
                                            <label for="exampleFormControlInput12">المرحلة الدراسية <span class="text-danger">*</span></label>
                                            <treeselect :options="stages" v-model="data.form.stage_id" @select="getGroups" :multiple="false" />
                                            <div class="invalid-feedback" :style="getErrors['stage_id'] ? 'display: block' : 'display: none;'"  v-if="getErrors['stage_id']">
                                                  {{ getErrors['stage_id'][0] }}
                                            </div>
                                        </div>
                                      </div>
                                      <div class="col-md-4">
                                        <div class="form-group mb-4">
                                            <label for="exampleFormControlInput12">الصف الدراسى <span class="text-danger">*</span></label>
                                           
                                            <treeselect :options="groups" v-model="data.form.group_id" :multiple="false" />

                                            <div class="invalid-feedback" :style="getErrors['group_id'] ? 'display: block' : 'display: none;'"  v-if="getErrors['group_id']">
                                                  {{ getErrors['group_id'][0] }}
                                            </div>
                                        </div>
                                      </div>
                                      <div class="col-md-4">
                                        <div class="form-group mb-4">
                                            <label for="exampleFormControlInput12">تاريخ الميلاد <span class="text-danger">*</span></label>
                                            <date-picker v-model="data.form.birth_date" @change="getAge()" :editable="true"  :calendar="'hijri'"></date-picker>
                                            <div class="invalid-feedback" :style="getErrors['birth_date'] ? 'display: block' : 'display: none;'"  v-if="getErrors['birth_date']">
                                                  {{ getErrors['birth_date'][0] }}
                                            </div>
                                        </div>
                                      </div>
                                      <div class="col-md-4">
                                        
                                         <label for="exampleFormControlInput12">العمر <span class="text-danger">*</span></label>
                                  <div class="input-group mb-4">
                                      
                                      <div class="input-group-prepend">
                                        <span class="input-group-text" id="basic-addon1"><i class="flaticon-file"></i></span>
                                      </div>
                                     
                                            <input type="text" class="form-control" v-model="data.form.age" placeholder="العمر" disabled> 
                                            <div class="invalid-feedback" :style="getErrors['age'] ? 'display: block' : 'display: none;'"  v-if="getErrors['age']">
                                                  {{ getErrors['age'][0] }}
                                            </div>
                                        </div>
                                      </div>
                                      <div class="col-md-4">
                                       
                                       <label for="exampleFormControlInput12">رقم هاتف المنزل</label>
                                  <div class="input-group mb-4">
                                      
                                      <div class="input-group-prepend">
                                        <span class="input-group-text" id="basic-addon1"><i class="flaticon-telephone"></i></span>
                                      </div>
                                           
                                            <input type="text" class="form-control" v-model="data.form.phone" placeholder="رقم تلفون المنزل">
                                            <div class="invalid-feedback" :style="getErrors['phone'] ? 'display: block' : 'display: none;'"  v-if="getErrors['phone']">
                                                  {{ getErrors['phone'][0] }}
                                            </div>
                                        </div>
                                      </div>

                                      <div class="col-md-6">
                                    
                                           <label for="exampleFormControlInput12"> رقم جوال ولى الامر <span class="text-danger">*</span></label>
                                  <div class="input-group mb-4">
                                      
                                      <div class="input-group-prepend">
                                        <span class="input-group-text" id="basic-addon1"><i class="flaticon-telephone"></i></span>
                                      </div>
                                     
                                            <input type="text" class="form-control" v-model="data.form.parent_mobile" placeholder="رقم جوال ولى الامر">
                                            <div class="invalid-feedback" :style="getErrors['parent_mobile'] ? 'display: block' : 'display: none;'"  v-if="getErrors['parent_mobile']">
                                                  {{ getErrors['parent_mobile'][0] }}
                                            </div>
                                        </div>
                                      </div>

                                      <div class="col-md-6">
                                      
                                     <label for="exampleFormControlInput12"> رقم جوال الطالب </label>
                                  <div class="input-group mb-4">
                                      
                                      <div class="input-group-prepend">
                                        <span class="input-group-text" id="basic-addon1"><i class="flaticon-telephone"></i></span>
                                      </div>
                                          
                                            <input type="text" class="form-control" v-model="data.form.mobile" placeholder="رقم جوال الطالب">
                                            <div class="invalid-feedback" :style="getErrors['mobile'] ? 'display: block' : 'display: none;'"  v-if="getErrors['mobile']">
                                                  {{ getErrors['mobile'][0] }}
                                            </div>
                                        </div>
                                      </div>

                                      <div class="col-md-6">
                                        <div class="form-group mb-4">
                                            <label for="exampleFormControlInput12">هل تم الالتحاق بحلقات التحفيظ قبل ذلك فى مسجد الكوثر؟ <span class="text-danger">*</span></label>
                                            <div class="row mt-2">
                                              <div class="col-md-2">
                                                <input type="radio" v-model="data.form.quaran_join" value="نعم"> <label for="">نعم</label>
                                              </div>
                                              <div class="col-md-2">
                                                <input type="radio" v-model="data.form.quaran_join" value="لا" > <label for="">لا</label>
                                              </div>
                                            </div>
                                            <div class="invalid-feedback" :style="getErrors['quaran_join'] ? 'display: block' : 'display: none;'"  v-if="getErrors['quaran_join']">
                                                  {{ getErrors['quaran_join'][0] }}
                                            </div>
                                        </div>
                                      </div>

                                      <div class="col-md-7">
                                        <div class="form-group mb-4">
                                            <label for="exampleFormControlInput12">هل تم الالتحاق بحلقات التحفيظ فى أى مسجد قبل هذه المرة؟ ... اين ؟ <span class="text-danger">*</span></label>
                                            <div class="row">
                                              <div class="col-md-2">
                                                <input type="radio" v-model="data.form.join_other" value="نعم"> <label for="">نعم</label>
                                              </div>
                                              <div class="col-md-2">
                                                <input type="radio" v-model="data.form.join_other" value="لا" > <label for="">لا</label>
                                              </div>
                                            </div>
                                            <div class="invalid-feedback" :style="getErrors['join_other'] ? 'display: block' : 'display: none;'"  v-if="getErrors['join_other']">
                                                  {{ getErrors['join_other'][0] }}
                                            </div>
                                        </div>
                                      </div>

                                      <div class="col-md-5" v-show="data.form.join_other == 'نعم'">
                                        <div class="form-group mb-4">
                                            <label for="exampleFormControlInput12"> مكان الحلقة</label>
                                            <input type="text" class="form-control" v-model="data.form.join_other_txt" placeholder="اين التحقت بالحلقات">
                                            <div class="invalid-feedback" :style="getErrors['join_other_txt'] ? 'display: block' : 'display: none;'"  v-if="getErrors['join_other_txt']">
                                                  {{ getErrors['join_other_txt'][0] }}
                                            </div>
                                        </div>
                                      </div>
                                      
                                      <div class="col-md-7">
                                        <div class="form-group mb-4">
                                            <label for="exampleFormControlInput12">هل تم اختبار أى فروع من فروع الاختبارات فى الجمعية قبل ذلك ... أى فرع ؟ <span class="text-danger">*</span></label>
                                            <div class="row">
                                              <div class="col-md-6">
                                                <input type="radio" v-model="data.form.choose_branch" value="نعم"> <label for="">نعم</label>
                                              </div>
                                              <div class="col-md-6">
                                                <input type="radio" v-model="data.form.choose_branch" value="لا" > <label for="">لا</label>
                                              </div>
                                            </div>
                                            <div class="invalid-feedback" :style="getErrors['choose_branch'] ? 'display: block' : 'display: none;'"  v-if="getErrors['choose_branch']">
                                                  {{ getErrors['choose_branch'][0] }}
                                            </div>
                                        </div>
                                      </div>

                                      <div class="col-md-5" v-if="data.form.choose_branch == 'نعم'">
                                        <div class="form-group mb-4">
                                            <label for="exampleFormControlInput12"> الفرع</label>
                                            <input type="text" class="form-control" v-model="data.form.choose_branch_txt" placeholder="الفرع">
                                            <div class="invalid-feedback" :style="getErrors['choose_branch_txt'] ? 'display: block' : 'display: none;'"  v-if="getErrors['choose_branch_txt']">
                                                  {{ getErrors['choose_branch_txt'][0] }}
                                            </div>
                                        </div>
                                      </div>

                                      <div class="col-md-12">
                                       
                                                                                   <label for="exampleFormControlInput12">كم مقدار الحفظ الذى تستطيع حفظه يومياً ؟ <span class="text-danger">*</span></label>

                                  <div class="input-group mb-4">
                                      
                                      <div class="input-group-prepend">
                                        <span class="input-group-text" id="basic-addon1"><i class="flaticon-file"></i></span>
                                      </div>
                                            <input type="text" class="form-control" v-model="data.form.save_daily_qty" placeholder="كم مقدار الحفظ الذى تستطيع حفظه يومياً ؟">
                                            <div class="invalid-feedback" :style="getErrors['save_daily_qty'] ? 'display: block' : 'display: none;'"  v-if="getErrors['save_daily_qty']">
                                                  {{ getErrors['save_daily_qty'][0] }}
                                            </div>
                                        </div>
                                      </div>
                                      
                                      <div class="col-md-12">
                                        <div class="form-group mb-4">
                                            <label for="exampleFormControlInput12">ما هى الطريقة التى اعتدت عليها فى الحفظ ؟ <span class="text-danger">*</span></label>
                                            <div class="row">
                                              <div class="col-md-3">
                                                <input type="radio" v-model="data.form.sav_way" value="مساعدة أحد الوالدين"> <label for="">مساعدة أحد الوالدين</label>
                                              </div>
                                              <div class="col-md-3">
                                                <input type="radio" v-model="data.form.sav_way" value="بمفردك" > <label for="">بمفردك</label>
                                              </div>
                                              <div class="col-md-1">
                                                <input type="radio" v-model="data.form.sav_way" value="طريقة أخرى" > <label for="">طريقة أخرى</label>
                                              </div>
                                               <div class="col-md-5" v-if="data.form.sav_way == 'طريقة أخرى'">
                                                <input type="text" name="sav_way" id="sav_way" class="form-control" v-model="data.form.sav_way_txt" placeholder="الطريقة الحفظ">
                                              </div>
                                            </div>
                                            <div class="invalid-feedback" :style="getErrors['sav_way'] ? 'display: block' : 'display: none;'"  v-if="getErrors['sav_way']">
                                                  {{ getErrors['sav_way'][0] }}
                                            </div>
                                            <div class="invalid-feedback" :style="getErrors['sav_way_txt'] ? 'display: block' : 'display: none;'"  v-if="getErrors['sav_way_txt']">
                                                  {{ getErrors['sav_way_txt'][0] }}
                                            </div>
                                        </div>
                                      </div>

                                    </div>
                                    
                                    </div>
                                  <div class="tab-pane fade" id="contact" role="tabpanel" aria-labelledby="contact-tab">
                                     <div class="row mt-4">
                                      <div class="col-md-4">
          <label for="exampleFormControlInput12">الاختبار <span class="text-danger">*</span></label>                                 
           <div class="input-group mb-4">
                                      
                                      <div class="input-group-prepend">
                                        <span class="input-group-text" id="basic-addon1"><i class="flaticon-file"></i></span>
                                      </div>
                                  
                                            <input type="text" class="form-control" v-model="data.form.test" placeholder="الاختبار">
                                            <div class="invalid-feedback" :style="getErrors['test'] ? 'display: block' : 'display: none;'"  v-if="getErrors['test']">
                                                  {{ getErrors['test'][0] }}
                                            </div>
                                        </div>
                                      </div>
                                      <div class="col-md-4">
                                        <div class="form-group mb-4">
                                            <label for="exampleFormControlInput12">السورة <span class="text-danger">*</span></label>
                                            <input type="text" class="form-control" v-model="data.form.sora" placeholder="اكتب السورة">
                                            <div class="invalid-feedback" :style="getErrors['sora'] ? 'display: block' : 'display: none;'"  v-if="getErrors['sora']">
                                                  {{ getErrors['sora'][0] }}
                                            </div>
                                        </div>
                                      </div>
                                      <div class="col-md-4">
                                        <div class="form-group mb-4">
                                            <label for="exampleFormControlInput12">من آيه <span class="text-danger">*</span></label>
                                            <input type="text" class="form-control" v-model="data.form.from_aya" placeholder="من آيه">
                                            <div class="invalid-feedback" :style="getErrors['from_aya'] ? 'display: block' : 'display: none;'"  v-if="getErrors['from_aya']">
                                                  {{ getErrors['from_aya'][0] }}
                                            </div>
                                        </div>
                                      </div>
                                      <div class="col-md-4">
                                        <div class="form-group mb-4">
                                            <label for="exampleFormControlInput12">إلى آيه <span class="text-danger">*</span></label>
                                            <input type="text" class="form-control" v-model="data.form.to_aya" placeholder="إلى آيه">
                                            <div class="invalid-feedback" :style="getErrors['to_aya'] ? 'display: block' : 'display: none;'"  v-if="getErrors['to_aya']">
                                                  {{ getErrors['to_aya'][0] }}
                                            </div>
                                        </div>
                                      </div>

                                      <div class="col-md-4">
                                        <div class="form-group mb-4">
                                            <label for="exampleFormControlInput12">تقدير التجويد <span class="text-danger">*</span></label>
                                            <v-select v-model="data.form.tagwid_avg" :options="['ضعيف', 'متوسط', 'جيد', 'جيد جداً', 'ممتاز']" />
                                            <div class="invalid-feedback" :style="getErrors['tagwid_avg'] ? 'display: block' : 'display: none;'"  v-if="getErrors['tagwid_avg']">
                                                  {{ getErrors['tagwid_avg'][0] }}
                                            </div>
                                        </div>
                                      </div>

                                      <div class="col-md-4">
                                        <div class="form-group mb-4">
                                            <label for="exampleFormControlInput12">تقدير الحفظ <span class="text-danger">*</span></label>
                                            <v-select v-model="data.form.save_avg" :options="['ضعيف', 'متوسط', 'جيد', 'جيد جداً', 'ممتاز']" />
                                            <div class="invalid-feedback" :style="getErrors['save_avg'] ? 'display: block' : 'display: none;'"  v-if="getErrors['save_avg']">
                                                  {{ getErrors['save_avg'][0] }}
                                            </div>
                                        </div>
                                      </div>

                                      <div class="col-md-4">
                                        <div class="form-group mb-4">
                                            <label for="exampleFormControlInput12">الاداء <span class="text-danger">*</span></label>
                                            <v-select v-model="data.form.pref_avg" :options="['ضعيف', 'متوسط', 'جيد', 'جيد جداً', 'ممتاز']" />
                                            <div class="invalid-feedback" :style="getErrors['pref_avg'] ? 'display: block' : 'display: none;'"  v-if="getErrors['pref_avg']">
                                                  {{ getErrors['pref_avg'][0] }}
                                            </div>
                                        </div>
                                      </div>

                                      <div class="col-md-4">
                                        <div class="form-group mb-4">
                                            <label for="exampleFormControlInput12">الصوت <span class="text-danger">*</span></label>
                                            <v-select v-model="data.form.sound_avg" :options="['ضعيف', 'متوسط', 'جيد', 'جيد جداً', 'ممتاز']" />
                                            <div class="invalid-feedback" :style="getErrors['sound_avg'] ? 'display: block' : 'display: none;'"  v-if="getErrors['sound_avg']">
                                                  {{ getErrors['sound_avg'][0] }}
                                            </div>
                                        </div>
                                      </div>

                                      <div class="col-md-4">
<label for="exampleFormControlInput12">اسم المختبر <span class="text-danger">*</span></label>
                                  <div class="input-group mb-4">
                                      
                                      <div class="input-group-prepend">
                                        <span class="input-group-text" id="basic-addon1"><i class="flaticon-file"></i></span>
                                      </div>
                                            
                                            <input type="text" class="form-control" v-model="data.form.test_name" placeholder="اسم المختبر">
                                            <div class="invalid-feedback" :style="getErrors['test_name'] ? 'display: block' : 'display: none;'"  v-if="getErrors['test_name']">
                                                  {{ getErrors['test_name'][0] }}
                                            </div>
                                        </div>
                                      </div>

                                      <div class="col-md-12">
                                      <label for="exampleFormControlInput12">التوصية <span class="text-danger">*</span></label>
                                  <div class="input-group mb-4">
                                      
                                      <div class="input-group-prepend">
                                        <span class="input-group-text" id="basic-addon1"><i class="flaticon-file"></i></span>
                                      </div>
                                           
                                            <input type="text" class="form-control" v-model="data.form.twsaya" placeholder="التوصية">
                                            <div class="invalid-feedback" :style="getErrors['twsaya'] ? 'display: block' : 'display: none;'"  v-if="getErrors['twsaya']">
                                                  {{ getErrors['twsaya'][0] }}
                                            </div>
                                        </div>
                                      </div>

                                    </div>

                                  </div>
                                  <div class="tab-pane fade" id="ident" role="tabpanel" aria-labelledby="ident-tab">
                                    <div class="row mt-4">
                                     
                                       <div :class="'col-md-12'">
                                        <div class="form-group mb-4">
                                            <label for="exampleFormControlInput12">رأى لجنةالحفظ والمراجعة <span class="text-danger">*</span></label>
                                            <div class="row">
                                              <div class="col-md-3">
                                                <input type="radio" @change="defaultStudentStatus();" v-model="data.form.opinion_of_teachers" value="مقبول"> <label for="">مقبول</label>
                                              </div>
                                              <div class="col-md-3">
                                                <input type="radio" @change="defaultStudentStatus();" v-model="data.form.opinion_of_teachers" value="غير مقبول" > <label for="">غير مقبول</label>
                                              </div>
                                            </div>
                                            <div class="invalid-feedback" :style="getErrors['opinion_of_teachers'] ? 'display: block' : 'display: none;'"  v-if="getErrors['opinion_of_teachers']">
                                                  {{ getErrors['opinion_of_teachers'][0] }}
                                            </div>
                                        </div>
                                      </div>

                                      <div :class="'col-md-12'">
                                        <div class="form-group mb-4">
                                            <label for="exampleFormControlInput12">رأى  لجنة السلوك والانضباط <span class="text-danger">*</span></label>
                                            <div class="row">
                                              <div class="col-md-3">
                                                <input type="radio" @change="defaultStudentStatus();" v-model="data.form.opinion_of_slok" value="مقبول"> <label for="">مقبول</label>
                                              </div>
                                              <div class="col-md-3">
                                                <input type="radio" @change="defaultStudentStatus();" v-model="data.form.opinion_of_slok" value="غير مقبول" > <label for="">غير مقبول</label>
                                              </div>
                                            </div>
                                            <div class="invalid-feedback" :style="getErrors['opinion_of_slok'] ? 'display: block' : 'display: none;'"  v-if="getErrors['opinion_of_slok']">
                                                  {{ getErrors['opinion_of_slok'][0] }}
                                            </div>
                                        </div>
                                      </div>

                                      <div class="col-md-12">
                                                                     <label for="exampleFormControlInput12"> ملاحظات السلوك <span class="text-danger">*</span></label>
                                  <div class="input-group mb-4">
                                      
                                      <div class="input-group-prepend">
                                        <span class="input-group-text" id="basic-addon1"><i class="flaticon-file"></i></span>
                                      </div>
                                            <input type="text" class="form-control" v-model="data.form.notes_of_slok" placeholder="ملاحظات السلوك">
                                            <div class="invalid-feedback" :style="getErrors['notes_of_slok'] ? 'display: block' : 'display: none;'"  v-if="getErrors['notes_of_slok']">
                                                  {{ getErrors['notes_of_slok'][0] }}
                                            </div>
                                        </div>
                                      </div>

                                      <div :class="'col-md-12'">
                                        <div class="form-group mb-4">
                                            <label for="exampleFormControlInput12">حالة الطالب <span class="text-danger">*</span></label>
                                            <div class="row">
                                              <div class="col-md-3">
                                                <input type="radio" v-model="data.form.status" value="مقبول"> <label for="">مقبول</label>
                                              </div>
                                              <div class="col-md-3">
                                                <input type="radio" v-model="data.form.status" value="غير مقبول" > <label for="">غير مقبول</label>
                                              </div>
                                            </div>
                                            <div class="invalid-feedback" :style="getErrors['status'] ? 'display: block' : 'display: none;'"  v-if="getErrors['status']">
                                                  {{ getErrors['status'][0] }}
                                            </div>
                                        </div>
                                      </div>

                                      <div class="col-md-12">
                                        <div class="form-group mb-4">
                                            <label for="exampleFormControlInput12">تاريخ المقابلة <span class="text-danger">*</span></label>
                                            <date-picker v-model="data.form.interview_date"  :calendar="'hijri'"></date-picker>
                                            <div class="invalid-feedback" :style="getErrors['interview_date'] ? 'display: block' : 'display: none;'"  v-if="getErrors['interview_date']">
                                                  {{ getErrors['interview_date'][0] }}
                                            </div>
                                        </div>
                                      </div>

                                    </div>
                                  </div>
                                </div>
                                
                                    <button type="submit" class="save-btn btn-creative btn-3 btn-3a flaticon-cart-fill" fdprocessedid="6b18p"><span>حفظ</span></button>
                                    <button type="button" @click.prevent="resetForm" class="rewrite-btn btn-creative btn-3 btn-3a flaticon-cart-fill" fdprocessedid="6b18p"><span>تفريغ</span></button>
                                    <router-link class="back-btn btn-creative btn-3 btn-3a flaticon-cart-fill" fdprocessedid="6b18p" :to="{name: 'interviews'}">
                                      <span>رجوع</span>
                                    </router-link>
                                  
                                  </form>
                               
                            </div>
                        </div>
                    </div>

                </div>

            </div>

</template>
<script>
import router from '@/router'
import 'vue-select/dist/vue-select.css';
import VueDatetimeJs from 'vue-datetime-js'
import Treeselect from '@riophae/vue-treeselect'
import '@riophae/vue-treeselect/dist/vue-treeselect.css'
export default {
  components: {
    datePicker: VueDatetimeJs,
    Treeselect
  },
  data() {
    return {
      date: '',
      stages: [],
      stage: '',
      groups: [],
      group: '',
      data: {
        checker: false,
        form:{
            name: '',
            birth_date: '',
            group_id: '',
            stage_id: '',
            lesson_id: '',
            age: '',
            phone: '',
            parent_mobile: '',
            mobile: '',
            quaran_join: '',
            quaran_join_txt: '',
            join_other: '',
            join_other_txt: '',
            choose_branch: '',
            choose_branch_txt: '',
            save_daily_qty: '',
            sav_way: '',
            sav_way_txt: '',
            test: '',
            sora: '',
            from_aya: '',
            to_aya: '',
            tagwid_avg: '',
            save_avg: '',
            pref_avg: '',
            sound_avg: '',
            test_name: '',
            twsaya: '',
            opinion_of_interviews: '',
            opinion_of_slok: '',
            notes_of_slok: '',
            status: '',
            interview_date: '',
        },
        roles: {
        },
        options: [],
        isRequested: false,
        errors: {},
        paginated: {}
      }
    };
  },
  created(){
    let parentId = this.$route.query.parent;
    let childId  = this.$route.query.child;
    if(parentId && childId){
      this.transParentData(parentId, childId);
    }else{
      router.push('/interviews');
    }
    this.getRequirements();
  },
  methods: {
    resetForm(){
     let parentId = this.$route.query.parent;
      let childId  = this.$route.query.child;
      if(parentId && childId){
        this.transParentData(parentId, childId);
      }else{
        this.data.form = {
            name: '',
            birth_date: '',
            group_id: '',
            stage_id: '',
            lesson_id: '',
            age: '',
            phone: '',
            parent_mobile: '',
            mobile: '',
            quaran_join: '',
            quaran_join_txt: '',
            join_other: '',
            join_other_txt: '',
            choose_branch: '',
            choose_branch_txt: '',
            save_daily_qty: '',
            sav_way: '',
            sav_way_txt: '',
            test: '',
            sora: '',
            from_aya: '',
            to_aya: '',
            tagwid_avg: '',
            save_avg: '',
            pref_avg: '',
            sound_avg: '',
            test_name: '',
            twsaya: '',
            opinion_of_interviews: '',
            opinion_of_slok: '',
            notes_of_slok: '',
            status: '',
            interview_date: '',
        };
      } 
    },
      defaultStudentStatus(){
        if(this.data.form.opinion_of_slok == 'مقبول' && this.data.form.opinion_of_teachers == 'مقبول'){
          this.data.form.status = 'مقبول';
        }

        if(this.data.form.opinion_of_slok == 'غير مقبول' && this.data.form.opinion_of_teachers == 'غير مقبول'){
          this.data.form.status = 'غير مقبول';
        }
        
      },
      transParentData(parentId, childId){
        this.$baseApi.get('/interviews/create?parent='+ parentId + '&child=' + childId).then((response)=>{
                    
              if(response.data.code == 200){
                let data = response.data.data.parent;
                if(data){
                  if(data.child.status == 0)
                    this.data.form.name = data.child.name;             
                    this.data.form.stage_id = (data.child.stage_id ? data.child.stage_id : data.stage_id);     
                    this.data.form.group_id = (data.child.group_id ? data.child.group_id : data.group_id);   

                    this.data.form.parent_mobile = data.mobile;     
                    this.data.form.parent_id = data.id;     
                    this.data.form.child = data.child.id;   

                    this.stages = response.data.data.stages; 
                    this.groups = response.data.data.groups;

                    if(data.group){
                      this.form.stage_id = data.group.stage_id;
                    }  
                }
                    

              }else{
                  alert(response.data.error.error);
              }
          });
      },
      getAge(){
        let year = new Intl.DateTimeFormat('ar-FR-u-ca-islamic', {year : 'numeric'}).format(Date.now());
        year = year.replace(/ هـ/g,'');
        let strArray = this.data.form.birth_date.split("/");
        let birth    = strArray[0];
        let age = Number(year) - Number(birth);
        if(age < 4){
          this.data.form.birth_date = '';
          this.data.form.age        = '';
          this.sweetAlert('العمر لابد ان يكون اكبر او يساوى 4 سنوات', 'error');
        }else{
        this.data.form.age = age;
        }
      },
      store(){
          this.data.isRequested = true;
         this.$baseApi.post('/interviews', this.data.form).then((response)=>{
            if(response.data.code === 200){
                localStorage.setItem('flash_message', 'تمت عملية الاضافة');
                router.push('/interviews');
            }
        }).catch((error) => {
            this.data.errors = JSON.parse(JSON.stringify(error.response.data.errors));
            this.data.isRequested = false
          })
      },
      getRequirements(){
        // this.getRoles();
      },
      getGroups(val){
         this.$baseApi.get('/interviews/create?option=group&i='+val.id).then((response)=>{
            if(response.data.code == 200){
               this.groups = response.data.data.groups;
            }else if(response.data.status == 401){
                this.error.auth = response.data.error.error;
            }else{
                alert(response.data.error.error);
            }
        });
      },
      getRoles(){
        this.$baseApi.get('/interviews/create').then((response)=>{
            if(response.data.code == 200){
               this.groups = response.data.data.groups;
               this.stages = response.data.data.stages;
            }else if(response.data.status == 401){
                this.error.auth = response.data.error.error;
            }else{
                alert(response.data.error.error);
            }
        });
      },
      selected(node, instanceId){
        this.data.form.location_id = node.id;
      },
      getTree(){
        this.$baseApi.get('/locations?tree=true' ).then((response)=>{
            if(response.data.code == 200){
              this.data.options = response.data.data;
            }else if(response.data.code == 401){
                this.error = response.data.error.error;
            }else{
                alert(response.data.error.error);
            }
        });
      },
  },
  computed: {
    trans(){
      return this.$store.getters.GET_TRANS;
    },
    user(){
      return this.$store.getters.SET_AUTH_USER;
    },
    getErrors() {
      return JSON.parse(JSON.stringify(this.data.errors))
    }
  },
  watch: {
    // Note: only simple paths. Expressions are not supported.
    stage(newValue) {
      this.data.form.stage_id = newValue.id;
    },
    group(newValue) {
      this.data.form.group_id = newValue.id;
    },
  }
};
</script>
<style>
</style>
